import { createSlice } from '@reduxjs/toolkit'
import { setErrorPage, unsetErrorPage } from './errorSlice'
import { setLoader, unsetLoader } from './loaderSlice'
import { getErrorMessage } from '../api/ApiDataHelper'
import { initViewer } from '../helpers/ViewerHelper'

const initialState = {
  viewerpageInitialized: false
}

export const initViewerpage = createSlice({
  name: 'initViewerpage',
  initialState,
  reducers: {
    resetInitViewerpageState: () => initialState,
    setViewerpageInitialized: (state, action) => {
      state.viewerpageInitialized = action.payload
    }
  }
})

export const {
  resetInitViewerpagetate,
  setViewerpageInitialized
} = initViewerpage.actions

export const initializeViewerpage = () => async (dispatch, getState) => {
  window.scrollTo(0, 0)
  dispatch(unsetErrorPage())
  const state = getState()
  const { viewerpageInitialized } = state.initViewerpage
  if (!viewerpageInitialized) {
    dispatch(setLoader())
    try {
      await Promise.all([
        initViewer(),
      ])
      dispatch(setViewerpageInitialized(true))
    }
    catch (error) {
      if (error.response?.status !== 401) {
        dispatch(setErrorPage({
          title: 'Errore richiesta server, impossibile inizializzare la pagina',
          message: getErrorMessage(error)
        }))
      }
    }
    finally {
      dispatch(unsetLoader())
    }
  }
}

export default initViewerpage.reducer
